import { useEffect } from "react";
import { initAnalytics, initInteractionTracking } from "@/lib/analytics";

export default function AnalyticsListener() {
  useEffect(() => {
    initAnalytics(); // no-op unless the visitor has already accepted cookies
    initInteractionTracking(); // safe: events are silently dropped until gtag loads
  }, []);
  return null;
}
